var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHomeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "32px",
    viewBox: "0 0 38 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homeowner-mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Monitoring-1",
    transform: "translate(-51.000000, -1089.000000)",
    fill: "#D1D3D4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape-Copy",
    points: "66.0588235 1121 66.0588235 1109.70588 73.5882353 1109.70588 73.5882353 1121 83 1121 83 1105.94118 88.6470588 1105.94118 69.8235294 1089 51 1105.94118 56.6470588 1105.94118 56.6470588 1121"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHomeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/home-icon.4336f66f3718fa140b133a7572423735.svg";